export default __webpack_public_path__ + "static/media/multi-source-discovery.0ec8192b.svg";